<template>
	<div ref="el" data-component="pre-loader">
		<span class="-h1 title">{{ title }}</span>
	</div>
</template>

<script setup>
import { getActiveContext } from '~/components/core/Page/context'

defineProps({
	title: { type: String, default: 'Buro Preload' },
})

const el = ref(null)
const scroller = inject('$scroller')
let removeTimer = null
let isRemoved = false

const removePreloader = () => {
	if (isRemoved) return
	isRemoved = true

	const context = getActiveContext()

	document.documentElement?.style.setProperty('--body-backgroundColor', '#161003')
	scroller?.value?.reset?.()
	const preloaderEl = el.value

	if (preloaderEl) {
		preloaderEl.classList.add('loaded')
		preloaderEl.remove()
	}

	context?.loader?.dispatch('ready')
	context?.loader?.dispatch('transition-ready')
}
onMounted(() => {
	removeTimer = setTimeout(() => {
		const context = getActiveContext()

		if (context) {
			context?.loader?.loaded.then(removePreloader)
			return
		}

		removePreloader()
	}, 1000)
})

onBeforeUnmount(() => {
	isRemoved = true

	if (removeTimer) clearTimeout(removeTimer)
})
</script>

<style lang="scss" scoped>
[data-component='pre-loader'] {
	position: fixed;
	top: 0;
	left: 0;

	display: flex;
	align-items: center;
	justify-content: center;
	width: 100svw;
	height: 200svh;

	background-color: var(--preload-color);
	color: var(--preload-color);

	z-index: 10000;

	pointer-events: none;

	&.loaded {
		display: none;
		width: 0;
		height: 0;
		visibility: hidden;
	}

	.title {
		font-size: 500px;
		color: var(--preload-color);
	}
}
</style>
